const LocationIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.63822 15.7613C11.1811 12.7154 13.5 9.92282 13.5 6.52215C13.5 2.92128 10.5899 0.00219727 7 0.00219727C3.41015 0.00219727 0.5 2.92128 0.5 6.52215C0.5 9.92282 2.81893 12.7154 6.36178 15.7613C6.72869 16.0768 7.2713 16.0768 7.63822 15.7613ZM7 9.0022C8.38071 9.0022 9.5 7.88291 9.5 6.5022C9.5 5.12149 8.38071 4.0022 7 4.0022C5.61929 4.0022 4.5 5.12149 4.5 6.5022C4.5 7.88291 5.61929 9.0022 7 9.0022Z"
        fill="#4747EB"
      />
    </svg>
  )
}

export default LocationIcon
